export default __webpack_public_path__ + "static/media/map-pin.24255c3e.svg";